import React, { lazy, Suspense } from 'react';
import { Loader } from 'semantic-ui-react'

const loadable = (importFunc, { fallback = null } = { fallback: null }) => {
  const LazyComponent = lazy(importFunc);
  let loader =
  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: window.innerHeight * .75 }}>
    <Loader size='massive' active inline='centered'>
      <span style={{ fontFamily: 'Roboto', color: '#444', fontWeight: '300' }}>
        <span className="loaderText">Loading</span>
        <span className='loaderSubText'>Content</span>
      </span>
    </Loader>
  </div>


  return props => (
    <Suspense fallback={fallback ? fallback : loader}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default loadable;
